/* Echt Groen , actieprijzen rechtstreeks bij Shopify opvragen.
 *
 * Waarom: een thema krijgt van Shopify nooit te horen dat er een korting bestaat. Een
 * productpagina kent alleen de gewone prijs; kortingen bestaan pas in de winkelwagen.
 * Daarom maakt dit script een LOSSE winkelwagen aan (die van de klant blijft ongemoeid),
 * laat Shopify daar zijn automatische kortingen op los, en zet de uitkomst op de kaartjes.
 *
 * Gevolg: zet je een korting aan, dan verschijnt de prijs vanzelf. Haal je hem weg, dan
 * verdwijnt hij vanzelf. Er wordt nergens iets weggeschreven, dus Everspring kan er ook
 * niets van overschrijven en er is geen tweede bron die kan gaan afwijken van de kassa.
 *
 * BEWUST GEEN OPSLAG. Een eerdere versie bewaarde de uitkomst tien minuten in de browser.
 * Dat scheelde aanvragen, maar liet een bezoeker tot tien minuten lang een actieprijs zien
 * die net was ingetrokken , precies het probleem dat deze hele opzet moest oplossen. Omdat
 * de haak alleen op producten uit de actiecollectie staat, zijn het er toch al weinig.
 */
(function () {
  "use strict";

  var CFG = window.EG_ACTIE || {};
  if (!CFG.token || !CFG.domein) return;
  if (CFG.uit) return;                       // hoofdschakelaar in de thema-instellingen

  // Zoekmachines overslaan. Ze hebben de actieprijs niet nodig (de feed werkt met de
  // gewone prijs) en het scheelt een winkelwagen per gecrawlde pagina.
  // (bewust niet op 'headless' filteren: daarmee sluit je ook de eigen controles buiten)
  if (/bot|crawl|spider|slurp|bingpreview|lighthouse|pagespeed/i.test(navigator.userAgent)) return;

  var API = "https://" + CFG.domein + "/api/2024-07/graphql.json";
  var MAX_PER_KEER = 50;                     // Shopify staat er 250 toe; 50 is ruim zat

  function geld(centen) {
    return "€" + (centen / 100).toFixed(2).replace(".", ",");
  }

  /* De span vullen met actieprijs + doorgestreepte oude prijs. */
  function toon(el, nuCenten, gewoonCenten) {
    // Een uitverkocht product komt als regel met aantal 0 en kosten 0 terug. Zonder deze
    // grens zou er doodleuk EUR 0,00 op de kaart komen te staan.
    if (!nuCenten || nuCenten <= 0) return;
    if (nuCenten >= gewoonCenten) return;    // geen korting: laten staan
    el.innerHTML =
      '<span class="eg-prijs__nu">' + geld(nuCenten) + "</span> " +
      '<s class="eg-prijs__was">' + geld(gewoonCenten) + "</s>";
    el.setAttribute("data-eg-klaar", "1");

    // Op een productpagina: de welkomskorting-regel weghalen. Die korting is niet te
    // combineren met een actie en rekent bovendien over de volle prijs.
    if (el.closest(".fp-price")) {
      document.documentElement.classList.add("fp-heeft-actie");
    }
  }

  /* Maatknopje op een collectiekaart: het bedrag gaat in het bubbeltje, niet in de tekst.
     Op het knopje zelf staat alleen de maat, want anders wordt de rij knopjes te breed. */
  function toonMaat(el, centen) {
    if (!centen || centen <= 0) return;
    var maat = (el.textContent || "").trim();
    el.setAttribute("title", maat + " voor " + geld(centen));
    el.setAttribute("data-eg-klaar", "1");
  }

  /* Hoeveel van de korting op deze regel komt van een stapelkorting (kies en mix)?
     Die geldt pas vanaf meerdere planten en hoort dus niet in de kaartprijs. */
  var STAPEL = /^(stapelkorting|kies en mix|kies & mix)/i;
  function stapelDeel(allocaties) {
    var som = 0;
    (allocaties || []).forEach(function (a) {
      if (a && a.title && STAPEL.test(a.title.trim())) {
        som += Math.round(parseFloat(a.discountedAmount.amount) * 100);
      }
    });
    return som;
  }

  function vraagOp(varianten, klaar, poging) {
    poging = poging || 1;
    var lijnen = varianten.map(function (id) {
      return { merchandiseId: "gid://shopify/ProductVariant/" + id, quantity: 1 };
    });
    var query =
      "mutation($lines:[CartLineInput!]!){cartCreate(input:{lines:$lines}){" +
      "cart{lines(first:" + MAX_PER_KEER + "){nodes{quantity " +
      "merchandise{... on ProductVariant{id}}" +
      "cost{amountPerQuantity{amount}totalAmount{amount}}" +
      "discountAllocations{discountedAmount{amount}" +
      "... on CartAutomaticDiscountAllocation{title}}}}}" +
      "userErrors{message}}}";

    fetch(API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": CFG.token
      },
      body: JSON.stringify({ query: query, variables: { lines: lijnen } })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        // Shopify knijpt geautomatiseerd verkeer af. Twee keer opnieuw proberen met een
        // korte pauze; lukt dat ook niet, dan blijft de gewone prijs gewoon staan.
        var geknepen = j && j.errors && j.errors.some(function (e) {
          return e.extensions && e.extensions.code === "THROTTLED";
        });
        if (geknepen && poging < 3) {
          setTimeout(function () { vraagOp(varianten, klaar, poging + 1); }, 900 * poging);
          return;
        }
        var cart = j && j.data && j.data.cartCreate && j.data.cartCreate.cart;
        if (!cart) return;
        var uit = {};
        cart.lines.nodes.forEach(function (l) {
          if (!l.quantity) return;           // uitverkocht: geen bruikbare prijs
          var id = l.merchandise.id.split("/").pop();
          var cent = Math.round(parseFloat(l.cost.totalAmount.amount) * 100);
          // Stapelkorting weer optellen. Deze proefwagen bevat tot vijftig planten, dus
          // Shopify vindt het minimum van 2/3/5 stuks altijd gehaald en trekt er 15% af.
          // Een bezoeker die EEN plant koopt krijgt die korting niet, dus hij hoort ook
          // niet in de getoonde prijs. Wat wel blijft staan: de weekactie en losse
          // kortingen per product.
          cent += stapelDeel(l.discountAllocations);
          if (cent > 0) uit[id] = cent;
        });
        klaar(uit);
      })
      .catch(function () { /* stil falen: dan blijft de gewone prijs staan */ });
  }

  function draai() {
    var elementen = [].slice.call(document.querySelectorAll(
      "[data-eg-var]:not([data-eg-klaar]), [data-eg-maat]:not([data-eg-klaar])"));
    if (!elementen.length) return;

    var teVragen = [];
    var perVariant = {};
    elementen.forEach(function (el) {
      var id = el.getAttribute("data-eg-var") || el.getAttribute("data-eg-maat");
      if (!id) return;
      (perVariant[id] = perVariant[id] || []).push(el);
      if (teVragen.indexOf(id) === -1) teVragen.push(id);
    });
    if (!teVragen.length) return;

    function verwerk(prijzen) {
      Object.keys(prijzen).forEach(function (id) {
        (perVariant[id] || []).forEach(function (el) {
          if (el.hasAttribute("data-eg-maat")) {
            toonMaat(el, prijzen[id]);
          } else {
            toon(el, prijzen[id], parseInt(el.getAttribute("data-eg-gewoon"), 10));
          }
        });
      });
    }

    /* In blokken van MAX_PER_KEER. Hier stond eerst slice(0, MAX_PER_KEER), waardoor alles
       boven de vijftigste variant stilletjes werd overgeslagen , op een collectiepagina met
       maatknopjes zijn dat er zo honderd. */
    for (var i = 0; i < teVragen.length; i += MAX_PER_KEER) {
      vraagOp(teVragen.slice(i, i + MAX_PER_KEER), verwerk);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", draai);
  } else {
    draai();
  }
  /* Secties die later inladen (filteren, doorbladeren) opnieuw meenemen. */
  document.addEventListener("shopify:section:load", draai);
})();
